import toggleMobileNavAnimation from "../animations/mobile_nav_animation"

// timeline
const animMobileNav = toggleMobileNavAnimation();

/**
 * Play or reverse the timeline animation for mobile nav
 */
const toggle_mobile_nav = () => {
    const body_el = document.body;
    const classMenuOpened = "mobile-nav-opened";
    body_el.classList.toggle(classMenuOpened);
    if(body_el.classList.contains(classMenuOpened) ){
        animMobileNav.play();
    }else{
        animMobileNav.reverse();
    }
}

/**
 * Default function : Add a listener for click event on the mobile nav button
 */
const mobile_nav_button_init = () => {
    const toggle_mobile_nav_button_el = document.querySelector("#burger-menu");
    toggle_mobile_nav_button_el.addEventListener("click", toggle_mobile_nav)
}

export default mobile_nav_button_init;
